import React, { useEffect, useState } from 'react';
import { View, ScrollView } from 'react-native';
import { connect } from 'react-redux';

import { notchTop, scale, width } from '@components/frame';
import { isPhone, workerType } from '@helpers';
import ColorWrapper from '@styles/colors';
import AnimatedHeader from '@components/common/AnimatedHeader';
import TouchableElement from '@components/common/touchableElement';
import UploadingBlock from './components/uploadingBlock';
import ConnectorBlock from './components/connectorBlock';
import Header from '@components/settings/v2/common/SettingsHeader';

import { useForceUpdate } from '@hooks/useForceUpdate';
import { BACK_BUTTON_SETTINGS_TEXT, SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';
import { buildSettingsNavParams } from '@components/settings/v2/common/navigationParams';

let interval;

const FileConnector = (props) => {
  const {
    C,
    connector: {
      connectorDetails: { status, version },
    },
    fileConnector: { updatedAt, data, connected },
    onlyMainBlock,
    navigation,
    rootStack = 'Settings',
  } = props;
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    interval = setInterval(() => {
      forceUpdate();
    }, 5000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  const fileConnectorStatus = status.find((i) => i.workerType === workerType.FILES) || {};

  const MainBlock = () => (
    <ConnectorBlock
      {...{
        C,
        version,
        fileConnectorStatus,
        updatedAt,
        connected,
        totalBytesSentPerSecond: data.totalBytesSentPerSecond,
        totalFiles: data.totalNcFileCountRemaining + data.totalErpFileCountRemaining + data.totalOtherFileCountRemaining,
        totalSize: data.totalNcFileSizeRemaining + data.totalErpFileSizeRemaining + data.totalOtherFileSizeRemaining,
        onlyMainBlock,
      }}
    />
  );

  if (onlyMainBlock) {
    return <MainBlock />;
  }

  return (
    <View style={{ height: '100%', width: '100%', backgroundColor: C('Background/Light/Detail'), alignItems: 'center' }}>
      <Header backBtnText="Connector" name={'FileConnector'} />
      <ScrollView style={{ width: '100%', flex: 1 }} contentContainerStyle={{ paddingBottom: scale(50) }}>
        <View style={[{ width: '100%', alignItems: 'center', paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL) }]}>
          <TouchableElement
            onPress={() =>
              isPhone
                ? null
                : navigation.navigate(rootStack, buildSettingsNavParams(rootStack, 'Connector', 'FileConnectorDetails'))
            }
          >
            {({ boxStyle }) => (
              <View style={[boxStyle, { width: '100%' }]}>
                <View style={{ width: '100%', alignItems: 'center' }}>
                  <MainBlock />
                </View>
                <View
                  style={{
                    width: '100%',
                    alignItems: 'stretch',
                    marginTop: scale(18),
                    flexDirection: isPhone ? 'column' : 'row',
                    justifyContent: 'space-between',
                    gap: scale(18),
                  }}
                >
                  <UploadingBlock
                    {...{
                      C,
                      name: 'NC files',
                      data: {
                        fileCountCompleted: data.totalNcFileCountCompleted,
                        fileCountRemaining: data.totalNcFileCountRemaining,
                        fileSizeCompleted: data.totalNcFileSizeCompleted,
                        fileSizeRemaining: data.totalNcFileSizeRemaining,
                      },
                    }}
                  />
                  <UploadingBlock
                    {...{
                      C,
                      name: 'Production linked files',
                      data: {
                        fileCountCompleted: data.totalErpFileCountCompleted,
                        fileCountRemaining: data.totalErpFileCountRemaining,
                        fileSizeCompleted: data.totalErpFileSizeCompleted,
                        fileSizeRemaining: data.totalErpFileSizeRemaining,
                      },
                    }}
                  />
                  <UploadingBlock
                    {...{
                      C,
                      name: 'Other files',
                      data: {
                        fileCountCompleted: data.totalOtherFileCountCompleted,
                        fileCountRemaining: data.totalOtherFileCountRemaining,
                        fileSizeCompleted: data.totalOtherFileSizeCompleted,
                        fileSizeRemaining: data.totalOtherFileSizeRemaining,
                      },
                    }}
                  />
                </View>
              </View>
            )}
          </TouchableElement>
        </View>
      </ScrollView>
    </View>
  );
};

export default connect(({ connector, fileConnector }) => ({ connector, fileConnector }), {})(ColorWrapper(FileConnector));
